import { Button, Color, Flex, Icon, IconButton, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useInitiateOpenBankingConnection } from '../../../../hooks/useInitiateOpenBankingConnection'
import { useOpenBankingAutoConnectModal } from '../../contexts/openBankingAutoConnectContext'
import * as Styled from '../LoadingModalBody/styles'

export const ConnectionFailedModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { handleCloseModal } = useOpenBankingAutoConnectModal()
  const { connectToOpenBanking, isProcessing } = useInitiateOpenBankingConnection()

  return (
    <Flex flexDirection="column" alignItems="center">
      <Styled.CloseButtonRow>
        <IconButton icon="x" onClick={handleCloseModal} />
      </Styled.CloseButtonRow>
      <Space size="s32" />
      <Styled.IconWrapper isLoading={false}>
        <Icon icon="circleX" color={Color.Red600} />
      </Styled.IconWrapper>
      <Space size="s40" />
      <Text weight="medium" variant="h3" alignment="center">
        {t('bank_connection.open_banking_auto_connect_modal.connection_failed_title')}
      </Text>
      <Space size="s8" />
      <Text variant="bodyLG" colorVariant="discreet" alignment="center">
        {t('bank_connection.open_banking_auto_connect_modal.connection_failed_description')}
      </Text>
      <Space size="s32" />
      <Button disabled={isProcessing} onClick={() => connectToOpenBanking()}>
        {t('bank_connection.open_banking_auto_connect_modal.connection_failed_button')}
      </Button>
    </Flex>
  )
}
